import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, toPathString } from './common.js';
import { BaseAPI, BASE_PATH, COLLECTION_FORMATS } from './base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * Recommendation API
 * API documentation for zootopia (recommendation-engine)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: Team_Dev_MadDragons@zooplus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SamplesApi - axios parameter creator
 * @export
 */
const SamplesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<number>} cartArticles Comma separated list of articles IDs already present in the cart
         * @param {number} siteId
         * @param {string} language
         * @param {number} [customerId] Uniques customer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSamples: async (cartArticles, siteId, language, customerId, options = {}) => {
            // verify required parameter 'cartArticles' is not null or undefined
            assertParamExists('getSamples', 'cartArticles', cartArticles);
            // verify required parameter 'siteId' is not null or undefined
            assertParamExists('getSamples', 'siteId', siteId);
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getSamples', 'language', language);
            const localVarPath = `/v1/sites/{site_id}/{language}/samples`
                .replace(`{${'site_id'}}`, encodeURIComponent(String(siteId)))
                .replace(`{${'language'}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, 'Authorization', configuration);
            if (cartArticles) {
                localVarQueryParameter['cart_articles'] = cartArticles.join(COLLECTION_FORMATS.csv);
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SamplesApi - functional programming interface
 * @export
 */
const SamplesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SamplesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Array<number>} cartArticles Comma separated list of articles IDs already present in the cart
         * @param {number} siteId
         * @param {string} language
         * @param {number} [customerId] Uniques customer identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSamples(cartArticles, siteId, language, customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSamples(cartArticles, siteId, language, customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    };
};
/**
 * SamplesApi - object-oriented interface
 * @export
 * @class SamplesApi
 * @extends {BaseAPI}
 */
class SamplesApi extends BaseAPI {
    /**
     *
     * @param {Array<number>} cartArticles Comma separated list of articles IDs already present in the cart
     * @param {number} siteId
     * @param {string} language
     * @param {number} [customerId] Uniques customer identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SamplesApi
     */
    getSamples(cartArticles, siteId, language, customerId, options) {
        return SamplesApiFp(this.configuration)
            .getSamples(cartArticles, siteId, language, customerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
}

export { SamplesApi, SamplesApiAxiosParamCreator, SamplesApiFp };
//# sourceMappingURL=api.js.map
